import styled from 'styled-components';

export const SuggestedUserItem = styled.li`
  &:not(&:last-of-type) {
    margin-bottom: 4px;
  }
`;

export const Box = styled.div`
  width: 100%;
`;

export const Subtitle = styled.p`
  line-height: 21px;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 8px;
  display: block;
`;
